import {
  ChangeDetectionStrategy,
  Component,
  forwardRef,
  input,
} from '@angular/core';
import { FormsModule, NG_VALUE_ACCESSOR } from '@angular/forms';
import { DropdownModule } from 'primeng/dropdown';
import { ControlFieldComponent } from '../control-field/control-field.component';
import { DropdownOption } from '../dropdown/dropdown.model';
import { PrimeNgControlComponent } from '../prime-ng-control/prime-ng-control.component';

@Component({
  selector: 'ui-country-select',
  standalone: true,
  imports: [DropdownModule, ControlFieldComponent, FormsModule],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => CountrySelectComponent),
      multi: true,
    },
  ],
  templateUrl: './country-select.component.html',
  styleUrl: './country-select.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CountrySelectComponent<
  T,
> extends PrimeNgControlComponent<T | null> {
  public readonly options = input<DropdownOption<T>[]>();
}
